import { createActionGroup, props } from '@ngrx/store';
import { RemoveWorkshopBookingsAndSetSeats, SetWorkshopBookingsAndSetSeats } from '@products/models/booking.model';

export const WorkshopBookingActions = createActionGroup({
  source: 'Workshop Product Booking',
  events: {
    'Set workshop in booking': props<SetWorkshopBookingsAndSetSeats>(),
    'Remove workshop from booking': props<RemoveWorkshopBookingsAndSetSeats>()
  }
});
